import { css } from "styled-components";
import STATES from "../consts";

var getCssState = function getCssState(state) {
  return function (_ref) {
    var theme = _ref.theme;

    if (state === STATES.HOVER) {
      return css(["background-color:", ";"], theme.orbit.paletteCloudLightHover);
    }

    if (state === STATES.FOCUS) {
      return css(["background-color:", ";"], theme.orbit.paletteCloudLight);
    }

    return null;
  };
};

export default getCssState;